import PasswordValidationComponent from "@components/find/PasswordValidationComponent";

export default function FindPassword() {
  return (
    <PasswordValidationComponent
      title="비밀번호를 입력해주세요."
      fieldName="newpassword"
      fieldConfirmName="newpasswordConfirm"
      modalMessage="비밀번호가 변경되었습니다."
      subMessage="다시 로그인 해주세요."
      type="resetPassword"
    />
  );
}
